module.exports = __webpack_public_path__ + "img/115.914f5a5a.jpg";